import React from "react";

const Content = ({ children }) => {
  return (
    <section className="w-[calc(100%-17rem)] max-h-[calc(100vh-12rem)] overflow-auto">
      {children}
    </section>
  );
};

export default Content;
